export default __webpack_public_path__ + "static/quickGuideImage-1b3d6a6aa8583e45b5b4c2b75cde2e41.png";